export default __webpack_public_path__ + "static/media/weather.a6af9d68.png";